import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollTop } from 'Core/hooks/useScrollTop';
import Page from 'Core/components/Page';
import Card from 'Core/components/FormElements/Card';
import Row from 'Core/components/Layout/Row';
import Column from 'Core/components/Layout/Column';
import warningIllustration from 'url:Images/illustrations/warning.svg';
import { createSecondaryFinancingPath } from 'Modules/patientfi/routes';
import InfoBox from 'Core/components/InfoBox';
import { stripErrorCodes } from 'Modules/patientfi/utils/errorCodes';

import { PrimaryButton } from 'Core/components/Button';
import { useNavigate } from 'react-location';
import classNames from 'classnames';

export default function FinancingDeclined({ allowCreateApplication = false, application = {} }) {
  document.title = 'Payment Portal - Application Declined';
  const { t } = useTranslation();
  useScrollTop();

  const navigate = useNavigate();
  const {
    customer_id = '',
    payload: { relationship = '', correction_required: { message = '' } = {} } = {},
  } = application;
  const handleCreateApplication = () => {
    const relationshipObj = JSON.stringify({ relationship, customer_id });
    sessionStorage.setItem('relationship', relationshipObj);
    navigate({
      to: createSecondaryFinancingPath,
      search: true,
    });
  };
  const descriptionLabel = allowCreateApplication
    ? 'financing.nextgen.declined.introWithNewApp'
    : 'financing.nextgen.declined.intro';

  return (
    <Page
      title={t('page.financing.header')}
      withStepProgress={false}
      stickyFooter
      branding="patientfi"
    >
      <Card className="justify-center !p-4 !pb-4 mt-8 mx-48" cardPadding="sm">
        <Row>
          <Column className="!flex-col-3"></Column>
          <h1
            className="font-light text-amber-600 flex gap-2 items-center ml-4"
            data-testid="title-finance-declined"
          >
            {t('common.nextgen.financingDeclined.title')}
          </h1>
        </Row>
        <Column>
          <hr className="mb-0"></hr>
        </Column>
        <Row className="items-start justify-center">
          <Column className="!flex-col-3 flex justify-center mt-0">
            <img alt="application-declined" width="200em" src={warningIllustration}></img>
          </Column>
          <Column className="!flex-col-9 !mb-0">
            <div
              className={classNames(
                'mb-0 w-full whitespace-pre-line text-lg leading-loose font-light mt-4'
              )}
            >
              {t(descriptionLabel)}
            </div>
            <div className="mt-4">
              <InfoBox type="warningLite" showBorder>
                <div className="font-bold mr-2 text-yellow-700 mb-0 inline-block">Reason:</div>{' '}
                {stripErrorCodes(message)}
              </InfoBox>
            </div>

            {allowCreateApplication && (
              <PrimaryButton
                data-testid="btn-create-secondary-application"
                className="mt-6 px-12"
                onClick={handleCreateApplication}
              >
                {t('common.reapply')}
              </PrimaryButton>
            )}
          </Column>
        </Row>
        <Row className="flex">
          <Column className="!flex-col-3"></Column>
          <Column className="!flex-col-3"></Column>
        </Row>
      </Card>
    </Page>
  );
}
